<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Rewrite: Loops in the Timescape, by Gregory Benford." class="imagefp" src="images/9781481487719.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?432aaa4d